export const DefaultParameters = () => {
    return {
        ProductURL: "https://llm.anygen.ai",
        AppStoreURL: "https://apps.anygen.ai",
        LoginRoute: "",
        SignupRoute: "/sign_up",
        UserProfileRoute: "/admin_dashboard",
        Cookie: "anyGen.ai-user-access-token",

    }
}


export const HubspotInfo = {
    HubspotPortalID:    "21105117",
    PricingPlanFormID:  "e1a1a0eb-e33b-41c9-a568-3b4914095929",
    RequestDemoFormID:  "8dd9c6ff-327f-4e2a-913c-36d493fbf262",
    NewsLetterFormID:   "feb48948-b51d-445f-93b7-dbfb5592b31c",
}
